




























import { TRIGGER_TYPE } from "@/config/alert";
import { Alert, DeliveryConfig } from "@/types/alert";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class AlertInfo extends Vue {
  @Prop({ required: true })
  alert!: Alert;

  @Getter("alerts/deliveryConfigByID") deliveryConfigByID!: (deliveryConfigID: number | null) => DeliveryConfig;

  defaultClass = "default";

  get deliveryConfig(): DeliveryConfig {
    return this.deliveryConfigByID(this.alert.delivery_config_id);
  }

  get triggerType() {
    if (this.alert.trigger_type) {
      return TRIGGER_TYPE[this.alert.trigger_type].label;
    }
    return TRIGGER_TYPE.hit_rate.label;
  }

  get triggerTypeClass() {
    if (!this.alert.trigger_type) return this.defaultClass;
    return "";
  }

  get comparison() {
    if (this.alert.trigger_type) {
      return TRIGGER_TYPE[this.alert.trigger_type].comparison;
    }
    return TRIGGER_TYPE.hit_rate.comparison;
  }

  get triggerThreshold() {
    if (this.alert.trigger_threshold) {
      return this.alert.trigger_threshold;
    }
    return 80;
  }

  get triggerThresholdClass() {
    if (!this.alert.trigger_threshold) return this.defaultClass;
    return "";
  }

  get deliveryType() {
    if (this.deliveryConfig.delivery_type) {
      return this.deliveryConfig.delivery_type;
    }
    return "email";
  }

  get deliveryTypeClass() {
    if (!this.deliveryConfig.delivery_type) return this.defaultClass;
    if (this.deliveryConfig.delivery_type === "slack") return "capitalize";
    return "";
  }

  get email() {
    if (this.deliveryConfig.email) {
      return this.deliveryConfig.email;
    }
    return "jane@example.com";
  }

  get emailClass() {
    if (!this.deliveryConfig.email) return this.defaultClass;
    return "";
  }

  get slackChannel() {
    if (this.deliveryConfig.slack_channel) {
      return this.deliveryConfig.slack_channel;
    }
    return "#alerts";
  }

  get slackChannelClass() {
    if (!this.deliveryConfig.slack_channel) return this.defaultClass;
    return "";
  }
}
